import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import PatientsGroupsListItem from './PatientsGroupsListItem';
import OverlayLoading from '../../../../Components/OverlayLoading';

interface Props {
	flatData: any[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
	isFlatDataLoading?: boolean;
}

const WRAPPER_ID = 'patientsGroupWrapper';

const PatientsGroupsList: React.FC<Props> = ({
	onRefresh,
	isLoading,
	hasMoreData,
	onLoadMore,
	flatData,
	isFlatDataLoading = false,
}) => {
	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			{isFlatDataLoading && <OverlayLoading />}
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey={'id'}
				renderItem={item => (
					<PatientsGroupsListItem item={item} refreshList={onRefresh} />
				)}
			/>
		</ScrollContainer>
	);
};

export default PatientsGroupsList;
